// Public quick-look modal (#assetQuickLookModal).
//
// Unlike the account browser's #assetDetailModal, which fills text nodes from a
// data-asset JSON blob, this fetches a server-rendered body from
// AssetsController#show.js. The acquisition block is per-visitor HTML — owned /
// buy this product / join the waitlist — and rendering it here would mean a
// second implementation of markup the detail page already owns, in JavaScript,
// with a fresh XSS surface. Fetching the whole body means both surfaces render
// the same partials and cannot drift.
//
// Cards are real links to the asset page, so a failed fetch just navigates.

const cache = new Map()
let skeleton = null
let sequence = 0

// While the modal is open the address bar shows the asset page's URL, so
// copying it shares the asset rather than the browse page it was opened from.
// returnUrl is the browse URL to put back when the modal closes; null while
// the modal is closed.
//
// replaceState, not pushState. Turbolinks owns the history entry for this
// page, and a pushed entry would make both Back and the close button pop into
// a Turbolinks restore visit — a full body re-render of the browse page, with
// the scroll position reset — to get rid of the modal. Rewriting the current
// entry in place leaves history untouched; Back still leaves the page as it
// did before. The state object is carried across unchanged so Turbolinks' and
// results_swap's markers on the entry survive.
let returnUrl = null

function showAssetUrl(url) {
  if (!window.history.replaceState) return

  if (returnUrl === null) returnUrl = window.location.href
  window.history.replaceState(window.history.state, "", url)
}

function restoreBrowseUrl() {
  if (returnUrl === null) return

  const url = returnUrl
  returnUrl = null
  window.history.replaceState(window.history.state, "", url)
}

function focusTitle(container) {
  const title = container.querySelector(".modal-title")
  if (!title) return

  title.setAttribute("tabindex", "-1")
  title.focus()
}

function fetchBody(url) {
  if (cache.has(url)) return $.Deferred().resolve(cache.get(url)).promise()

  return $.ajax({ method: "GET", url: url, dataType: "json" }).then(
    function (response) {
      cache.set(url, response.html)
      return response.html
    }
  )
}

$(document).on("turbolinks:load", function () {
  const $content = $("#assetQuickLookModal .js-quick-look-content")
  if ($content.length && skeleton === null) skeleton = $content.html()
})

// Warm the cache on intent, so the common case opens with no visible wait.
$(document).on("mouseenter focusin", ".js-quick-look", function () {
  fetchBody($(this).attr("href"))
})

$(document).on("show.bs.modal", "#assetQuickLookModal", function (event) {
  const trigger = event.relatedTarget
  if (!trigger) return

  const url = trigger.getAttribute("href")
  const $content = $(this).find(".js-quick-look-content")
  const mine = ++sequence

  showAssetUrl(url)

  // aria-busy before the swap, so assistive tech suppresses the skeleton
  // rather than announcing it as a live update.
  $content.attr("aria-busy", "true").html(skeleton)

  fetchBody(url)
    .done(function (html) {
      // A newer open won the race; painting this one would show the wrong asset.
      if (mine !== sequence) return

      // Replacing the subtree destroys whatever inside it had focus — which is
      // the skeleton's title whenever the fetch resolves after shown.bs.modal.
      // Removing a focused node sends focus to <body> WITHOUT firing focusin,
      // so Bootstrap's focus enforcement never catches it and the user falls
      // out of the dialog. Restore it onto the real title.
      const hadFocus = $content[0].contains(document.activeElement)

      $content.html(html).attr("aria-busy", "false")

      if (hadFocus) focusTitle($content[0])
    })
    .fail(function () {
      // Same guard as done: a superseded open failing late must not navigate
      // away from the asset the visitor opened since.
      if (mine !== sequence) return

      Turbolinks.visit(url)
    })
})

// Move focus onto the asset's name once the body has landed, so a screen
// reader announces what opened rather than leaving focus on the dialog.
$(document).on("shown.bs.modal", "#assetQuickLookModal", function () {
  focusTitle(this)
})

$(document).on("hidden.bs.modal", "#assetQuickLookModal", function () {
  restoreBrowseUrl()
})

// Leaving the page from inside the modal — "View asset page →", the library
// link, or the fetch-failure fallback — skips hidden.bs.modal: Turbolinks
// replaces the body with the modal still open. Put the browse URL back before
// Turbolinks pushes the new entry, or the entry behind it would point at the
// asset page too and Back would appear to do nothing.
$(document).on("turbolinks:before-visit", function () {
  restoreBrowseUrl()
})

// Turbolinks caches the DOM, so a restored page would otherwise flash the
// previously opened asset before its own fetch resolves.
//
// The snapshot is also taken with the modal still open when the visit started
// from inside it, and Bootstrap's hide() is animated, so it cannot finish
// before the snapshot. Undo the open state by hand, or Back lands on the
// browse page with an empty skeleton dialog sitting over the grid.
$(document).on("turbolinks:before-cache", function () {
  const $modal = $("#assetQuickLookModal")
  if (!$modal.length) return

  $modal
    .find(".js-quick-look-content")
    .html(skeleton)
    .attr("aria-busy", "false")

  $modal
    .removeClass("show")
    .css("display", "")
    .attr("aria-hidden", "true")
    .removeAttr("aria-modal role")
  $(".modal-backdrop").remove()
  $(document.body).removeClass("modal-open").css({
    overflow: "",
    paddingRight: "",
  })
})
